import { __makeTemplateObject } from '../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Text, ArrowRightIcon } from '@elseu/sdu-titan';
import styled, { css } from 'styled-components';
import { Link } from '../Link/Link.js';

/**
 * The styled component for the Card
 */
var StyledCard = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme,
    isProduct = _a.isProduct;
  return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    background: ", ";\n    box-shadow: 0 15px 25px rgba(88, 77, 52, 0.05), 0 5px 10px rgba(88, 77, 52, 0.05);\n    border-radius: ", ";\n    max-width: 100%;\n    height: 100%;\n\n    ", "\n  "], ["\n    display: flex;\n    flex-direction: column;\n    background: ", ";\n    box-shadow: 0 15px 25px rgba(88, 77, 52, 0.05), 0 5px 10px rgba(88, 77, 52, 0.05);\n    border-radius: ", ";\n    max-width: 100%;\n    height: 100%;\n\n    ", "\n  "])), theme.designTokens.colors.grey0, theme.borderRadius[2], isProduct && "\n      word-break: break-word;\n      word-wrap: break-word;\n      hyphens: auto;\n      box-shadow: none;\n      ");
});
/**
 * The styled component for the image container
 */
var ImageContainer = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme,
    isProduct = _a.isProduct;
  return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    position: relative;\n    width: 100%;\n    padding-bottom: ", ";\n    overflow: hidden;\n\n    & img {\n      position: ", ";\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n\n      border-radius: ", " ", " 0 0;\n    }\n  "], ["\n    position: relative;\n    width: 100%;\n    padding-bottom: ", ";\n    overflow: hidden;\n\n    & img {\n      position: ", ";\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n\n      border-radius: ", " ", " 0 0;\n    }\n  "])), !isProduct ? '56.25%' : '0', !isProduct ? 'absolute' : 'static', theme.borderRadius[2], theme.borderRadius[2]);
});
/**
 * The styled component for the content
 */
var Content = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme,
    isProduct = _a.isProduct;
  return css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    padding: ", ";\n  "], ["\n    padding: ", ";\n  "])), !isProduct ? theme.spacing[8] : "".concat(theme.spacing[8], " ").concat(theme.spacing[4]));
});
/**
 * The styled component for the title
 */
var Title = styled(Text)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  display: block;\n  margin: 0;\n  padding-bottom: ", ";\n  word-break: break-word;\n  hyphens: auto;\n"], ["\n  display: block;\n  margin: 0;\n  padding-bottom: ", ";\n  word-break: break-word;\n  hyphens: auto;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.spacing[1];
});
/**
 * The styled component for the subtitle
 */
var Subtitle = styled(Text)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  display: block;\n  padding-bottom: ", ";\n"], ["\n  display: block;\n  padding-bottom: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.spacing[1];
});
/**
 * The styled component for the label
 */
var Label = styled(Text)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  display: block;\n"], ["\n  display: block;\n"])));
/**
 * The styled component for the description
 */
var Description = styled(Text)(templateObject_10 || (templateObject_10 = __makeTemplateObject([""], [""])));
/**
 * The styled component for the price
 */
var Price = styled(Text)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  display: block;\n"], ["\n  display: block;\n"])));
/**
 * The styled component for the footer
 */
var Footer = styled.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  justify-content: space-between;\n"])));
/**
 * The Card component
 *
 * @param {CardProps} props - The props for the Card component.
 * @returns {JSX.Element} The Card component.
 */
var Card = function (_a) {
  var title = _a.title,
    image = _a.image,
    description = _a.description,
    label = _a.label,
    subtitle = _a.subtitle,
    price = _a.price,
    button = _a.button,
    isProduct = _a.isProduct;
  return jsxs(StyledCard, {
    isProduct: isProduct,
    children: [image && jsx(ImageContainer, {
      isProduct: isProduct,
      children: image
    }), jsxs(Content, {
      isProduct: isProduct,
      children: [title && jsx(Title, {
        as: "h3",
        type: "headerSmall",
        children: title
      }), subtitle && jsx(Subtitle, {
        as: "span",
        type: "label",
        children: subtitle
      }), label && jsx(Label, {
        as: "span",
        type: "label",
        children: label
      }), jsx(Description, {
        as: "p",
        type: "paragraph",
        children: description
      }), (button || price) && jsxs(Footer, {
        children: [price && jsx(Price, {
          as: "span",
          type: "label",
          children: price
        }), button && jsx(Link, {
          to: button.href,
          suffixAdornment: jsx(ArrowRightIcon, {}),
          isExternal: button.external,
          children: button.label
        })]
      })]
    })]
  });
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;

export { Card, StyledCard };
//# sourceMappingURL=Card.js.map
